import React from 'react';
import {assign} from 'lodash';
import {fill} from './constants/Styles';
import {styledDiv, themeable, emotionStyled} from '@packages/utilities/styled';
import {translate, margin} from '@packages/utilities/inline-style-utils';

export const Bar = styledDiv(
  ({theme: {scrollbar}, style, length, large}) =>
    assign(
      {
        position: 'relative',
        width: large ? scrollbar.widthLarge : scrollbar.width,
        height: length,
        overflow: 'hidden',
      },
      style
    ),
  {
    horizontal: ({theme: {scrollbar}, length, large}) => ({
      width: length,
      height: large ? scrollbar.widthLarge : scrollbar.width,
    }),
  }
);

Bar.displayName = 'UiScrollbar.Bar';

export const Track = styledDiv(
  ({
    theme: {scrollbar, animation},
    horizontal,
    length,
    position,
    dragging,
    hoveringTrack = false,
    scrolling = false,
  }) => {
    const bottomOrRight: string = horizontal ? 'bottom' : 'right';
    const widthOrHeight: string = horizontal ? 'width' : 'height';
    return {
      position: 'absolute',
      top: 0,
      left: 0,
      [bottomOrRight]: 0,
      display: 'flex',
      flexDirection: horizontal ? 'row' : 'column',
      [widthOrHeight]: length,
      backgroundColor:
        hoveringTrack || dragging || scrolling
          ? scrollbar.trackColorHightlight
          : scrollbar.trackColor,
      transition: `background-color ${animation.duration} ${animation.easing}`,
      transform: horizontal ? translate(position, 0) : translate(0, position),
    };
  }
);

Track.displayName = 'UiScrollbar.Track';

export const TrackPiece = emotionStyled('div')({flexGrow: 1});

TrackPiece.displayName = 'UiScrollbar.TrackPiece';

export const Thumb = themeable(
  ({
    theme: {scrollbar, animation},
    // @ts-expect-error - TS2339 - Property 'length' does not exist on type '{ theme: Theme; } & RefAttributes<any> & { children?: ReactNode; }'.
    length,
    // @ts-expect-error - TS2339 - Property 'horizontal' does not exist on type '{ theme: Theme; } & RefAttributes<any> & { children?: ReactNode; }'.
    horizontal,
    // @ts-expect-error - TS2339 - Property 'hoveringTrack' does not exist on type '{ theme: Theme; } & RefAttributes<any> & { children?: ReactNode; }'.
    hoveringTrack,
    // @ts-expect-error - TS2339 - Property 'hoveringThumb' does not exist on type '{ theme: Theme; } & RefAttributes<any> & { children?: ReactNode; }'.
    hoveringThumb,
    // @ts-expect-error - TS2339 - Property 'scrolling' does not exist on type '{ theme: Theme; } & RefAttributes<any> & { children?: ReactNode; }'.
    scrolling,
    // @ts-expect-error - TS2339 - Property 'dragging' does not exist on type '{ theme: Theme; } & RefAttributes<any> & { children?: ReactNode; }'.
    dragging,
    // @ts-expect-error - TS2339 - Property 'large' does not exist on type '{ theme: Theme; } & RefAttributes<any> & { children?: ReactNode; }'.
    large,
    ...rest
  }) => {
    const centerPadding = (scrollbar.width - scrollbar.thumbWidth) / 2;

    return (
      <div
        {...rest}
        style={{
          position: 'relative',
          flexBasis: length,
        }}
      >
        <div
          style={assign(
            {
              margin: horizontal
                ? margin(centerPadding, 0)
                : margin(0, centerPadding),
              borderRadius: large
                ? scrollbar.thumbBorderRadiusLarge
                : scrollbar.thumbBorderRadius,
              backgroundColor: hoveringThumb
                ? scrollbar.thumbColorHightlightWhileHoveringThumb
                : dragging || scrolling
                  ? scrollbar.thumbColorHightlight
                  : hoveringTrack
                    ? scrollbar.thumbColorWhileHoveringTrack
                    : scrollbar.thumbColor,
              transition: `background-color ${animation.duration} ${animation.easing}`,
            },
            fill
          )}
        />
      </div>
    );
  }
);

Thumb.displayName = 'UiScrollbar.Thumb';
